var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"height":"auto","fixed":"fixed"}},[_c('v-card',{staticClass:"flex"},[_c('v-card-actions',{staticClass:"justify-center"},[_c('v-icon',[_vm._v("copyright")]),_c('b',[_vm._v(_vm._s(_vm.$store.state.anyoFooter)+" | "+_vm._s(_vm.$store.state.appName))])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }